let stickyColumnIntervalInteration = 0;
let stickyColumnInterval = 0;

export function init() {
    if (document.querySelector('.variant__table')) {
        setupHeaderSort();
        variantLink();
        showMore();
        searchFunctionDesktop();
        searchFunctionMobile();

        /**
         * Minor timeout to let other scripts run first.
         */
        stickyColumnInterval = setInterval(() => calculateStickyColumnPositions(true), 500);

        window.addEventListener('resize', onWindowResize)
    }
}

let resizeTimeout = 0;
function onWindowResize() {
    if (resizeTimeout) {
        clearTimeout(resizeTimeout);
    }

    resizeTimeout = setTimeout(calculateStickyColumnPositions, 100);
}

function setupHeaderSort() {
    const variantTable = document.querySelector('.variant__table');
    const tableHeaders = variantTable.querySelectorAll(
        'th[data-field-sortable].variant__table__header'
    );
    tableHeaders.forEach(
        (x) => x.onclick = (event) => {
            const dataFieldId = event.target.parentNode.dataset.fieldId;
            const sortAscending = event.target.parentNode.dataset.fieldSortDescending === 'true' && event.target.parentNode.dataset.fieldSorted === 'true';
            const sortDescending = !sortAscending;
            event.target.parentNode.dataset.fieldSortDescending = sortDescending;

            const sortedHeader = variantTable.querySelector('th[data-field-sorted="true"].variant__table__header');
            if (sortedHeader) {
                sortedHeader.dataset.fieldSorted = 'false';
            }
            event.target.parentNode.dataset.fieldSorted = 'true';

            sortTableColumn(dataFieldId, sortDescending);
        }
    );
}

const tryParseDecimal = (value) => {
    let maybeDecimal = parseFloat(value.replace(',','.').replace(' ',''));
    if (isNaN(maybeDecimal)) return value;
    return maybeDecimal;
}

function sortTableColumn(fieldId, sortDescending = true) {
    if(typeof fieldId === 'undefined' || fieldId.trim() === '') return;

    // parseFloat(str.replace(',','.').replace(' ',''))
    const compareFunction = (a, b) => ((v1, v2) => v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ?
            v1 - v2 :
            v1.toString().localeCompare(v2))(sortDescending ? a.value : b.value, sortDescending ? b.value : a.value);

    const variantTable = document.querySelector('.variant__table');
    const originalListItems = variantTable.querySelectorAll('.variant__table__row');
    //To get if the table is collapsed or not
    let variantHiddenList = variantTable.querySelectorAll('.variant__table__row.hidden');

    let sortList = [];
    sortList = Array.from(originalListItems).map((item, index) => ({
        originalListIndex: index,
        value: tryParseDecimal(item.querySelector('[data-field-id=' + fieldId + '].variant__table__cell').dataset.fieldValue) || 0
    }));
    sortList.sort(compareFunction);

    let tableBody = variantTable.querySelector('tbody');
    originalListItems.forEach(x => x.remove());
    //For removing the class 'hidden' from the table when the sorted item is hidden on the collapsed table
    sortList.forEach((row, index) => {
        originalListItems[index].classList.add('hidden')
        if (!variantHiddenList.length) {
            originalListItems[index].classList.remove('hidden')
        } else {
            if (row.originalListIndex <= 2) {
                originalListItems[index].classList.remove('hidden')
            }
        }
    })

    sortList.forEach(x => tableBody.appendChild(originalListItems[x.originalListIndex]));
}

function showMore() {
    const showMoreElem = document.querySelector('.js-show-all');
    if (showMoreElem) {
        showMoreElem.addEventListener('click', function () {
            showMoreElem.style.display = 'none';
            let variantrows = document.querySelectorAll('.variant__table__row');
            variantrows.forEach((row) => {
                row.classList.remove('hidden');
            });

            calculateStickyColumnPositions();
        });
    }
}

function variantLink() {
    const link = document.querySelector('.js-to-variants-link');

    link.addEventListener('click', function () {
        const variantSelectorElement = document.getElementById('variant-selector');
        variantSelectorElement.scrollIntoView({behavior: 'smooth'});
    });
}

function searchFunctionDesktop() {
    const searchField = document.querySelectorAll('.js-variant-selector-search-desktop');

    [...searchField].forEach((search) => {
        search.onkeyup = () => {
            const filter = search.value.toUpperCase();
            const trs = document.querySelectorAll('.variant__table tbody tr');

            [...trs].forEach((tr) => {
                tr.style.display = GetElementDisplayValueFromSearch(tr, filter);
            });
        };
    });
}

function searchFunctionMobile() {
    const searchField = document.querySelectorAll(
        '.js-variant-selector-search-mobile'
    );

    [...searchField].forEach((search) => {
        search.onkeyup = () => {
            const filter = search.value.toUpperCase();
            const trs = document.querySelectorAll('.js-variant-item-mobile');

            [...trs].forEach((tr) => {
                tr.style.display = GetElementDisplayValueFromSearch(
                    tr,
                    filter
                );
            });
        };
    });
}

const AddToCart = function (checkBoxes, button) {
    if (checkBoxes.length > 0) {
        let variantIds = [];
        [...checkBoxes].forEach((checkBox) =>
            variantIds.push(checkBox.dataset.variantId)
        );
        window.__litium.events.onBulkAddToCartButtonClick(button, variantIds, null);
    }
};

const GetElementDisplayValueFromSearch = function (element, filter) {
    let showElement = [...element.children].find((td) =>
        td.textContent.toUpperCase().includes(filter)
    );

    return showElement ? '' : 'none';
};

const calculateStickyColumnPositions = (iterate = false) => {
    if (iterate && stickyColumnIntervalInteration >= 3) {
        clearInterval(stickyColumnInterval);
    }

    const variantTable = document.querySelector('.variant__table');

    const priceCols = variantTable.querySelectorAll('.js-price-col');
    const qtyCols = variantTable.querySelectorAll('.js-qty-col');
    const buyCols = variantTable.querySelectorAll('.js-buy-col');
    const pdfCols = variantTable.querySelectorAll('.js-pdf-col');

    let qtyColWidth, buyColWidth, pdfColWidth = 0;

    if (pdfCols.length) {
        let onlyHeader = qtyCols.length === 1;
        pdfColWidth = pdfCols[onlyHeader ? 0 : 1].offsetWidth;
    }

    if (qtyCols.length) {
        let onlyHeader = qtyCols.length === 1;
        qtyColWidth = qtyCols[onlyHeader ? 0 : 1].offsetWidth;
    }

    if (buyCols.length) {
        let onlyHeader = buyCols.length === 1;
        buyColWidth = buyCols[onlyHeader ? 0 : 1].offsetWidth - 1;
    }

    buyCols.forEach(el => el.style.right = (!isNaN(pdfColWidth) ? pdfColWidth : 0) + 'px');
    qtyCols.forEach(el => el.style.right =
        (!isNaN(pdfColWidth) ? pdfColWidth : 0) +
        (!isNaN(buyColWidth) ? buyColWidth : 0) + 'px'
    );

    priceCols.forEach(el => el.style.right =
        (!isNaN(pdfColWidth) ? pdfColWidth : 0) +
        (!isNaN(buyColWidth) ? buyColWidth : 0) +
        (!isNaN(qtyColWidth) ? qtyColWidth : 0) + 'px'
    );

    if (iterate) {
        stickyColumnIntervalInteration++;
    }
}

export { calculateStickyColumnPositions };